<div class="slide-caption-container"  data-swiper-parallax="-300" data-swiper-parallax-duration="600" >
    <div  class="slide-caption">
        <h2 fittext [maxFontSize]="42">{{data.city}}</h2> 
        
        <div  class="temperature">
            <img *ngIf="data.forecast && data.forecast.length > 0 && data.forecast[0].WeatherSymbolUrl" 
             src="{{data.forecast[0].WeatherSymbolUrl}}">
            <h2  *ngIf="data.weather != null && data.weather.Temperature != null">{{data.weather.Temperature}}&#8451;</h2>
        </div>
        
        <div  class="forecastContainer">
          
           <div fittext [maxFontSize]="22" class="sääennuste">{{data.city}} sääennuste</div> 
          <!--  <div class="sääennuste">FMI</div>-->
            <app-line-chart *ngIf="data.forecast && data.forecast.length > 0" [forecast]="data.forecast"></app-line-chart>
            <p *ngIf="data.forecast && data.forecast.length > 0" class="refreshtime">Sääennusteen tarjoaa Ilmatieteen laitos</p>
            
            <!-- <div class="sääennuste">Yrno</div> -->
            
             <app-line-chart *ngIf="data.forecastYrno && data.forecastYrno.length > 0" [forecast]="data.forecastYrno"></app-line-chart>
            <p *ngIf="data.forecastYrno && data.forecastYrno.length > 0" class="refreshtime">Weather forecast from Yr, delivered by the Norwegian Meteorological Institute and NRK</p>
          
            <p class="refreshtime" *ngIf="data.refreshtime && data.refreshtime.toLocaleString">Säätiedot päivitetty {{data.refreshtime.toLocaleString('fi', { hour: "2-digit",minute: "2-digit"})}} (päivitysväli 30 min)</p>
    <!-- 
            
    
            <div   class="forecast" *ngFor="let x of data.forecast | timePipe">
                <p  class="ennustePäivä "> {{x.Time.toLocaleString('fi', {weekday:"short"})}}</p>
                <p class="ennusteAika "> {{x.Time.toLocaleString('fi', { hour: "2-digit",minute: "2-digit"})}}</p>
                <img class="ennusteSäätila" src="{{x.WeatherSymbolUrl}}">
                <p  class="ennusteLämpö "> {{x.Temperature | number: '1.1-1'}}&#8451;</p>
                
            </div>
            <p class="refreshtime"*ngIf="data.refreshtime">Säätiedot päivitetty {{data.refreshtime.toLocaleString('fi', { hour: "2-digit",minute: "2-digit"})}} (päivitysväli 5 min)</p>

            -->
        </div>
        
    </div>
    
    </div> 
    
    